import React from "react";
import { Link, Navigate } from "react-router-dom";
import { Container, Typography, Button, Paper } from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import { getAuthToken, getRole } from "../services/tokenService";

const Unauthorized = () => {
  const token = getAuthToken();
  const role = getRole();
  if (token && role) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: "center", borderRadius: 2 }}>
        <Typography component="h1" variant="h4" sx={{ fontWeight: "bold", color: "#b71c1c", mb: 1 }}>
          401 Unauthorized
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You must sign in to access the portal. This page is not available without logging in.
        </Typography>
        <Button
          component={Link}
          to="/"
          variant="contained"
          size="large"
          sx={{ bgcolor: deepPurple[500], "&:hover": { bgcolor: deepPurple[700] } }}
        >
          Go to Sign In
        </Button>
      </Paper>
    </Container>
  );
};

export default Unauthorized;
